import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/App.css';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SendZNS from './pages/SendZNS';
import SendBulkZNS from './pages/SendBulkZNS';
import Templates from './pages/Templates';
import Sidebar from './components/Sidebar';
import AutomationRules from './pages/AutomationRules';

// Protected Route Component with Layout
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        {children}
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/send-zns"
            element={
              <ProtectedRoute>
                <SendZNS />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/send-bulk-zns"
            element={
              <ProtectedRoute>
                <SendBulkZNS />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/templates"
            element={
              <ProtectedRoute>
                <Templates />
              </ProtectedRoute>
            }
          />
          
		  // Trong phần routes, thêm:
			<Route 
			  path="/automation" 
			  element={
				<ProtectedRoute>
				  <AutomationRules />
				</ProtectedRoute>
			  } 
			/>
		  
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </Router>
  );
}

export default App;